import { Capacitor } from '@capacitor/core';

// Evaluate once at module load — Capacitor.isNativePlatform() is synchronous
// and never changes during a session, so a hook with useEffect/useState is
// unnecessary and can cause a brief "false" flash on first render.
export const IS_NATIVE = Capacitor.isNativePlatform();

export const useNativePlatform = (): boolean => IS_NATIVE;
